import React from "react";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Link } from 'react-router-dom';


const Footer = () => {

  const handleAboutClick = (e) => {
    if (window.location.pathname !== "/") {
      e.preventDefault();
      window.history.pushState({}, "", "/");
      window.dispatchEvent(new PopStateEvent("popstate"));
      // Delay scroll until homepage mounts
      setTimeout(() => {
        const el = document.getElementById("products");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100); // adjust delay if needed
    } else {
      const el = document.getElementById("products");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };


  return (
    <footer className="text-white pt-5 pb-3 fs-6" style={{ backgroundColor: 'rgb(4,180,228)' }}>
      <div className="container">
        <div className="row justify-content-center text-center text-md-start">
          {/* Menu */}
          <div className="col-6 col-md-2 mb-4">
            <h5 className="fw-bold mb-3">Menu</h5>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-white text-decoration-none"
                onClick={() => {
                  if (window.location.pathname === "/") {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >Home</Link></li>
              <li><Link className="custom-underline nav-link" to="/#products" onClick={handleAboutClick}>About Us</Link>
              </li>
              <li><Link to="/our-partners" className="text-white text-decoration-none"
                onClick={() => {
                  if (window.location.pathname === "/our-partners") {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >Partner With Us</Link></li>
              <li><Link to="/career" className="text-white text-decoration-none"
                onClick={() => {
                  if (window.location.pathname === "/career") {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >Career</Link></li>
              <li><Link to="/contact-us" className="text-white text-decoration-none"
                onClick={() => {
                  if (window.location.pathname === "/contact-us") {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >Contact</Link></li>
              <li><Link to="/privacy-policy" className="text-white text-decoration-none"
                onClick={() => {
                  if (window.location.pathname === "/privacy-policy") {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }}
              >Privacy Policy</Link></li>
            </ul>
             {/* <br></br> <Link className="text-uppercase text-center small" to="/privacy-policy" style={{ textDecoration: 'none', color: '#dcdcdc' }}>- Privacy Policy -</Link> */}
          </div>

          {/* Our Products */}
          <div className="col-12 col-md-3 mb-4">
            <h5 className="fw-bold mb-3">Our Products</h5>
            <ul className="list-unstyled">
              <li><Link to="/warals-school-management-system" className="text-white text-decoration-none">School Management System</Link></li>
              <li><Link to="/warals-institute-management-system" className="text-white text-decoration-none">Institute Management System</Link></li>
              <li><a href="/warals-learning-management-system" className="text-white text-decoration-none">Learning Management System</a></li>
              <li><Link to="/warals-website-develop" className="text-white text-decoration-none">Website Development</Link></li>
            </ul>
          </div>

          {/* Address */}
          <div className="col-12 col-md-3 mb-4">
            <h5 className="fw-bold mb-3"><i className="fas fa-map-marker-alt me-2"></i>Address</h5>
            <p className="mb-2 fw-bold">WARALS Technology Private Limited</p>
            <p className="mb-0">G-35, Kalindi Kunj Rd, Nai Basti, Jamia Nagar, Okhla, Delhi, New Delhi, Delhi 110025</p>

            {/* <h5 className="fw-bold mb-3"><i className="fas fa-map-marker-alt me-2"></i>Corporate Office Address</h5> */}
            {/* <p className="my-2 fw-bold">Corporate Office Address</p>
            <p className="mb-0">N-18, South Extension Part-1 New Delhi 110049</p> */}
          </div>

          {/* Phone & Mail */}
          <div className="col-12 col-md-2 mb-4">
            <h5 className="fw-bold mb-3"><i className="fas fa-phone me-2"></i>Phone</h5>
            <p className="mb-2">
              <a href="tel:+919871115060" className="text-white text-decoration-none">+91 98711 15060</a>
            </p>
            <h5 className="fw-bold mb-2"><i className="fas fa-envelope me-2"></i>Mail</h5>
            <a href="mailto:info@warals.com" className="text-white text-decoration-none d-block mb-1">
              info@warals.com
            </a>
            {/* <small>24 x 7 online support</small> */}
          </div>

          {/* Social Links */}
          <div className="col-12 col-md-2 mb-4">
            <h5 className="fw-bold mb-3"><i className="fas fa-share-alt me-2"></i>Follow Us</h5>
            <ul className="list-unstyled d-flex justify-content-center justify-content-md-start gap-3 mb-3">
              <li><a href="https://www.facebook.com/waralstechnology/" className="text-white fs-5"><i className="fab fa-facebook-f"></i></a></li>
              <li><a href="https://www.instagram.com/warals_technology/" className="text-white fs-5"><i className="fab fa-instagram"></i></a></li>
              <li><a href="https://www.youtube.com/@waralstechnology6005" className="text-white fs-5"><i className="fab fa-youtube"></i></a></li>
              <li><a href="https://x.com/WaralsT" className="text-white fs-5"><i className="fab fa-x-twitter"></i></a></li>
              <li><a href="https://www.linkedin.com/company/waralstechnology" className="text-white fs-5"><i className="fab fa-linkedin-in"></i></a></li>
            </ul>
          </div>
        </div>

        <hr className="border-secondary my-4" />

        <div className="text-center small">
          Copyright © 2025 <a href="https://warals.com/" className="text-white text-decoration-none">Warals.com</a> | All Rights Reserved
        </div>
        {/* <br></br> <Link className="text-uppercase text-center small" to="/privacy-policy" style={{ textDecoration: 'none', color: '#dcdcdc' }}>- Privacy Policy -</Link> */}
      </div>
    </footer>

  );
};

export default Footer;
